import { Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { reposService } from '@/services/api';
import { useAsync } from '@/common/hooks/use-async';
import { AsyncBoundary } from '@/common/components/async-boundary';

// Workspaces come from backend config (BITBUCKET_WORKSPACES) — the Bitbucket API token
// cannot enumerate workspaces, so the set is configured server-side. Repos within a
// workspace are listed live. See plan/M4-REPOS-ONBOARDING.md.
export default function Workspaces() {
  const { data, loading, error } = useAsync(() => reposService.listWorkspaces(), []);
  const items = data?.items ?? [];
  return (
    <Card>
      <Card.Header>Onboard — pick a workspace ({items.length})</Card.Header>
      <Card.Body>
        <p className="text-muted">Pick a workspace to browse its repos and onboard them.</p>
        <AsyncBoundary loading={loading} error={error}>
          <ListGroup>
            {items.map((w) => (
              <ListGroup.Item
                key={w.slug}
                action
                as={Link}
                to={`/onboarding/workspace?workspace=${encodeURIComponent(w.slug)}`}
              >
                {w.name || w.slug}
              </ListGroup.Item>
            ))}
            {!items.length && <ListGroup.Item className="text-muted">No workspaces configured.</ListGroup.Item>}
          </ListGroup>
        </AsyncBoundary>
      </Card.Body>
    </Card>
  );
}
